import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Constants } from 'src/app/constants';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { ReasonidService } from 'src/app/service/reasonid.service';

@Component({
    selector: 'app-add-reason-id',
    templateUrl: './add-reason-id.component.html',
    styleUrls: ['./add-reason-id.component.scss'],
    standalone: false
})
export class AddReasonIdComponent implements OnInit {

  heading: string;
  errormsg
  eventType
  reasonId
  reasonName
  category
  includeInInvestigation
  includeInAll
  selected_position_id: any;
  TierData: any;
  categoryId: any;
  categoryDropDown: any;
  categoryDrop: any;
  yesNoList: { id: string; value: string; }[];

  constructor(public dialogRef: MatDialogRef<AddReasonIdComponent>, private readonly constants: Constants,
    @Inject(MAT_DIALOG_DATA) public dataStore: any,
    private readonly ngxUiLoaderService: NgxUiLoaderService, private readonly reasonid: ReasonidService) { }

  ngOnInit(): void {
    this.yesNoList = [
      { id: "1", value: 'Yes' },
      { id: "0", value: 'No' },
    ]
    this.heading = this.dataStore.header;
    this.eventType = this.dataStore.eventType;
    this.categoryDropDown = this.dataStore.categoryDrop;

    if (this.eventType == 'EDIT') { // NOSONAR
      this.reasonId = this.dataStore.reasonId.toString();
      this.reasonName = this.dataStore.reasonName
      this.categoryDrop = this.dataStore.categoryId
      this.includeInInvestigation = this.dataStore.includeInInvestigation == "Y" ? "1" : "0"; // NOSONAR
      this.includeInInvestigation = this.yesNoList.find(x => x.id == this.includeInInvestigation)?.id // NOSONAR
      this.includeInAll = this.dataStore.includeInAll == "Y" ? "1" : "0"; // NOSONAR
      this.includeInAll = this.yesNoList.find(x => x.id == this.includeInAll)?.id // NOSONAR
      this.categoryId = this.categoryDropDown?.find(x => x.value == this.dataStore.categoryId)?.value // NOSONAR
    }
  }


  close(): void {
    this.dialogRef.close(
      { event: 'CloseEvent' }
    );
  }
  onNoClick(): void {
    this.dialogRef.close({
      event: "NoEvent"
    });
  }
  public saveClick() {

    this.errormsg = ""

    if (this.isValueOk(this.reasonName)) {
      this.showError(this.constants.formInputError);
    } else if (this.isValueOk(this.reasonId)) {
      this.showError(this.constants.formInputError);
    } else if (this.isValueOk(this.categoryId)) {
      this.showError(this.constants.formInputError);
    } else if (this.isValueOk(this.includeInInvestigation)) {
      console.info(this.includeInInvestigation)
      this.showError(this.constants.formInputError);
    } else if (this.isValueOk(this.includeInAll)) {
      console.info("5")
      this.showError(this.constants.formInputError);
    }

    else {
      this.saveAPICall();
    }
  }

  keyPressAlphaNumeric(event) {
    const inp = String.fromCharCode(event.keyCode);
    if (/[0-9]/.test(inp)) {
      return true;
    } else {
      event.preventDefault();
      return false;
    }
  }

  saveAPICall() {
    this.errormsg = ""
    this.ngxUiLoaderService.start(this.constants.LoaderComponent)

    if (this.eventType == "ADD") { // NOSONAR
      const updateObject = {
        reasonId: Number(this.reasonId),
        description: this.reasonName,
        categoryId: this.categoryDropDown?.find(x => x.value == this.categoryId).label, // NOSONAR
        includeInvestigation: this.includeInInvestigation == "1" ? "1" : "0", // NOSONAR
        includeInAll: this.includeInAll == "1" ? "1" : "0", // NOSONAR

      }
      this.reasonid.addReasonId(updateObject).subscribe(
        response => {
          this.ngxUiLoaderService.stop(this.constants.LoaderComponent)
          if (response == "Successfully Inserted") { // NOSONAR
            this.dialogRef.close({
              event: "SaveEvent",
              eventType: this.eventType,
            });
          } else {
            this.showError(response);
          }
        }, error => {
          console.info(error)
          this.showError(this.constants.APIErrorMessage);

        });

    }
    else if (this.eventType == "EDIT") { // NOSONAR
      const updateObject = {
        reasonId: Number(this.reasonId),
        description: this.reasonName,
        categoryId: this.categoryDropDown?.find(x => x.value == this.categoryId).label, // NOSONAR
        includeInvestigation: this.includeInInvestigation == "1" ? "1" : "0", // NOSONAR
        includeInAll: this.includeInAll == "1" ? "1" : "0", // NOSONAR
      }
      this.ngxUiLoaderService.start(this.constants.LoaderComponent)

      this.reasonid.updateReasonId(updateObject).subscribe(
        response => {

          if (response == "Successfully Updated") { // NOSONAR
            this.dialogRef.close({
              event: "SaveEvent",
              eventType: this.eventType,
            });
          } else {
            this.showError(response);
          }

        }, error => {
          console.info(error)
          this.showError(this.constants.APIErrorMessage);
        });
    }

  }


  showError(message) {
    this.ngxUiLoaderService.stop(this.constants.LoaderComponent)
    this.errormsg = message;
    setTimeout(() => {
      this.errormsg = ""
    }, this.constants.notificationMessageTimeShort);
  }

  isValueOk(param: any): boolean {
    if (param == undefined || param == null || param == "") // NOSONAR
    {
      return true;
    }
    return false;
  }

  ifNullSetZero(param) {
    return Number(param ? param : 0);

  }

}

